import { DecimalPipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { LeadStatusService } from 'src/app/shared/services/leadStatus.services';
import { UserServices } from 'src/app/shared/services/userservices';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { ReportService } from 'src/app/utility/ReportService';

@Component({
  selector: 'app-counsellor-performance',
  templateUrl: './counsellor-performance.component.html',
  styleUrls: ['./counsellor-performance.component.css']
})
export class CounsellorPerformanceComponent implements OnInit {

  selectedCounsellors: string[] = [];
  counsellors: any[] = [];

  selectedCounsellor: string = 'all';

  data: any[] = [];
  allData: any[] = [];

  displayedColumns: string[];

  totalRecords = 0;
  totalPages = 1;  // For pagination display
  pageSize = 12;
  currentPage = 1;
  isAllSelected = true;
  loading = false;
  fromDate: any;
  toDate: any;

  statusColumns: string[] = [];  // ← FIXED TYPE
  tableData: any = [];

  constructor(private userService: UserServices,
    private leadStatusService: LeadStatusService,
    private decimalPipe: DecimalPipe,
    private reportService: ReportService, private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    this.getUsersList();                  // Load counsellors
    this.getLeadStatus();
    this.applyPagination();

    this.fromDate = this.localStorage.get("showMeLeadsFromDate");
    this.toDate = new Date();
  }
  getLeadStatus() {
    this.leadStatusService.getAllLeadStatus()
      .subscribe((resp: any[]) => {

        let dynamicStatusColumns = resp.map(s => s.statusName);

        // Add to displayedColumns
        this.displayedColumns = ["Counsellor Name","Total Leads", ...dynamicStatusColumns,
          "conversion%"];
      });
  }
  getUsersList() {
    this.userService.getUsersActive()
      .subscribe(
        resp => {
          this.counsellors = resp;

          // FIX: select all AFTER list loads
          this.selectedCounsellors = this.counsellors.map(c => c.refNo);
          this.isAllSelected = true;
        },
        (error: HttpErrorResponse) => { }
      );
  }

  applyFilter() {
    this.loading = true;

    this.reportService.getCounsellorPerformance(
      this.selectedCounsellors,
      this.formatDate(this.fromDate),
      this.formatDate(this.toDate),
      0,  // page (will be ignored)
      10000  // size (fetch all)
    ).subscribe({
      next: (res) => {
        const allData = res.map(item => {
          const flatRow: any = {
            "Counsellor Name": item.counsellorName,
            "Total Leads":item.totalLeads
          };
          let adm = 0;
          // flatten statusCounts into columns
          Object.keys(item.statusCounts).forEach(status => {
            flatRow[status] = item.statusCounts[status];
            if (status == "Seat Booked" || status == "Admission Taken")
              adm = item.statusCounts[status];
          });
          // you can compute conversion% if required
          // flatRow["conversion%"] = this.calculateConversion(item.statusCounts);
          if (adm == 0)
            flatRow["conversion%"] = 0
          else
            flatRow["conversion%"] = this.decimalPipe.transform(((adm/item.totalLeads)*100), '1.2-2'); ;
          return flatRow;
        });

        // Store all data and apply client-side pagination
        this.allData = allData;
        this.totalRecords = allData.length;
        this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
        this.currentPage = 1;  // Reset to first page

        // Apply pagination to show current page data
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.tableData = allData.slice(start, end);

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      }
    });
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    // Apply client-side pagination
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.tableData = this.allData.slice(start, end);
  }

  getPaginationPages(): number[] {
    const pages = [];
    const totalPages = this.totalPages || 1;
    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(totalPages, this.currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  applyPagination() {
    this.data = this.allData.slice(0, this.pageSize);
  }

  fetchData() {
    this.currentPage = 1;
    this.applyFilter();
  }

  toggleSelectAll() {
    if (this.isAllSelected) {
      this.selectedCounsellors = [];
      this.isAllSelected = false;
    } else {
      this.selectedCounsellors = this.counsellors.map(c => c.refNo);
      this.isAllSelected = true;
    }
  }

  formatDate(date: any): string | null {
    if (!date) return null;
    return new Date(date).toISOString().substring(0, 10);
  }

  onCounsellorChange() {
    this.isAllSelected =
      this.selectedCounsellors.length === this.counsellors.length;
  }

  selectAll() {
    this.selectedCounsellors = this.counsellors.map(x => x.refNo);
  }

  deselectAll() {
    this.selectedCounsellors = [];
  }
}
